import { render, staticRenderFns } from "./ChangePasswordConfirmation.vue?vue&type=template&id=38a60926"
import script from "./ChangePasswordConfirmation.vue?vue&type=script&lang=js"
export * from "./ChangePasswordConfirmation.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordConfirmation.vue?vue&type=style&index=0&id=38a60926&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports